import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import PropTypes, { customPagePropType } from '../../helpers/propTypes';
import usePageAria from '../../hooks/usePageAria';
import Markdown from '../Md';
import { MainHeading, NormalText, SubtleText } from '../typography';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'auto',
  },

  container: {
    flexGrow: 1,
    width: '100%',
    maxWidth: 750,
    margin: 'auto',
    textAlign: 'center',
    padding: '0 30px',

    [theme.breakpoints.down('sm')]: {
      padding: '20px 10px',
    },

    '& > *': {
      marginBottom: 28,

      '&:first-child': {
        marginTop: 56,

        [theme.breakpoints.down('xs')]: {
          marginTop: 28,
        },
      },

      '&:last-child': {
        marginBottom: 56,
      },
    },
  },

  iconContainer: {
    maxWidth: '100%',
    maxHeight: 200,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,

    [theme.breakpoints.down('sm')]: {
      height: 100,
    },

    '& svg': {
      height: '100%',
    },
  },
}));

function Md(props) {
  return (
    <Markdown
      {...props}
      overrideComponents={{ p: (elProps) => <div {...elProps} /> }}
    />
  );
}

function MessagePage({
  icon,
  title,
  text,
  showButton,
  buttonText,
  onButtonClick,
  subText,
  customPage,
}) {
  const aria = usePageAria();
  const classes = useStyles();

  const _text = customPage.text ? (
    <Md tags={customPage.tags}>{customPage.text}</Md>
  ) : (
    text
  );
  const _subText = customPage.subText ? (
    <Md tags={customPage.tags}>{customPage.subText}</Md>
  ) : (
    subText
  );
  const buttonClickHandler = () => onButtonClick(customPage.buttonAction);

  return (
    <div className={classes.root} {...aria}>
      <div className={classes.container}>
        {icon && (
          <div aria-hidden="true" className={classes.iconContainer}>
            {icon}
          </div>
        )}
        <MainHeading noUnderline={!_text && !_subText}>
          {customPage.title || title}
        </MainHeading>
        {_text && <NormalText>{_text}</NormalText>}
        {_subText && <SubtleText variant="subtitle1">{_subText}</SubtleText>}
        {showButton && (
          <Button
            color="primary"
            onClick={buttonClickHandler}
            variant="contained"
          >
            {customPage.buttonText || buttonText}
          </Button>
        )}
      </div>
    </div>
  );
}

MessagePage.propTypes = {
  buttonText: PropTypes.node,
  customPage: customPagePropType,
  icon: PropTypes.node,
  onButtonClick: PropTypes.func,
  showButton: PropTypes.bool,
  subText: PropTypes.node,
  text: PropTypes.node,
  title: PropTypes.node.isRequired,
};

MessagePage.defaultProps = {
  buttonText: undefined,
  customPage: {},
  icon: null,
  onButtonClick: undefined,
  showButton: false,
  subText: undefined,
  text: undefined,
};

export default MessagePage;
